// extracted by mini-css-extract-plugin
module.exports = {"HeadingIcon":"HeadingIcon_HeadingIcon__1J10L"};